import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AnalyticsState } from '../reducer/analytics.reducer';

export const selectAnalyticsState = createFeatureSelector<AnalyticsState>('analytics');

export const selectAnalyticsLoadingState = createSelector(selectAnalyticsState, (state) => state.loading);

export const selectAnalyticsError = createSelector(selectAnalyticsState, (state) => state.error);

export const selectAnalyticsSuccessState = createSelector(selectAnalyticsState, (state) => state.success);
